export default ($page) => {
    return [
        {
            route: 'contracts.contracts',
            label: 'messages.sitemap.contracts.contracts',
            showInSidebar: true,
            permissions: ['contracts.contract'],
            id: 'contracts-contracts-index'
        },
        {
            route: 'contracts.pending',
            label: 'messages.sitemap.contracts.pending_index',
            showInSidebar: true,
            permissions: ['contract.pending'],
            id: 'contracts-pending-index'
        },
        {
            route: 'contracts.terminations',
            label: 'messages.sitemap.contracts.terminations',
            showInSidebar: true,
            permissions: ['contract.manage_terminations'],
            id: 'contracts-terminations'
        },
        {
            route: 'tools.fulfillment.index',
            label: 'messages.sitemap.tools.fulfillment.fulfillment',
            showInSidebar: true,
            permissions: ['contract.fulfillment'],
            id: 'contracts-fulfillment-index'
        },
        {
            route: 'contracts.duplicates',
            label: 'messages.sitemap.contracts.duplicates',
            showInSidebar: true,
            permissions: ['contract.duplicates'],
            id: 'contracts-duplicates-index'
        },
        {
            route: 'contracts.transfers',
            label: 'messages.sitemap.contracts.transfers',
            showInSidebar: true,
            permissions: ['contract.transfer.cancel'],
            id: 'contracts-transfers-index'
        },
        {
            route: 'contracts.domains',
            label: 'messages.sitemap.contracts.domains',
            showInSidebar: true,
            permissions: ['contract.fulfillment'],
            id: 'contracts-domains-index'
        },
        {
            route: 'contracts.pricing.index',
            label: 'messages.sitemap.contracts.pricings.index',
            showInSidebar: true,
            permissions: ['contract.pricings'],
            id: 'contracts-pricing-index',
            children: [
                {
                    route: 'contracts.pricing.preview',
                    label: 'messages.sitemap.contracts.pricings.preview',
                    showInSidebar: false,
                    permissions: ['contract.pricings'],
                    id: 'contracts-pricing-preview'
                },
                {
                    route: 'contracts.pricing.upload-page',
                    label: 'messages.sitemap.contracts.pricings.upload',
                    showInSidebar: false,
                    permissions: ['contract.pricings'],
                    id: 'contracts-pricing-upload-page'
                },
                {
                    route: 'contracts.pricing.preview-upload',
                    label: 'messages.sitemap.contracts.pricings.preview-upload',
                    showInSidebar: false,
                    permissions: ['contract.pricings'],
                    id: 'contracts-pricing-preview-upload'
                }
            ]
        },
        {
            route: 'contracts.contract-upload.index',
            label: 'messages.sitemap.contracts.upload.index',
            showInSidebar: true,
            permissions: ['contract.upload'],
            id: 'contracts-upload-index',
            children: [
                {
                    route: 'contracts.contract-upload.upload-page',
                    label: 'messages.sitemap.contracts.upload.upload',
                    showInSidebar: false,
                    permissions: ['contract.upload'],
                    id: 'contracts-csv-upload-page'
                },
                {
                    route: 'contracts.contract-upload.show',
                    label: 'messages.sitemap.contracts.upload.show',
                    showInSidebar: false,
                    permissions: ['contract.upload'],
                    id: 'contracts-csv-show-page'
                },
                {
                    route: 'contracts.contract-upload.preview',
                    label: 'messages.sitemap.contracts.upload.preview',
                    showInSidebar: false,
                    permissions: ['contract.upload'],
                    id: 'contracts-csv-preview-page'
                }
            ]
        },
        ...($page.props.modules.php_eol_addon
            ? [
                {
                    route: 'contracts.php-eol-bulk.index',
                    label: 'messages.sitemap.contracts.php_eol.bulk',
                    showInSidebar: true,
                    permissions: ['contract.fulfillment'],
                    id: 'php-eol-bulk-index',
                    children: [
                        {
                            route: 'contracts.php-eol-first-email-candidates.index',
                            label: 'messages.sitemap.contracts.php_eol.first_email_candidates',
                            showInSidebar: false,
                            permissions: ['contract.fulfillment'],
                            id: 'php-eol-first-email-candidates-index'
                        },
                        {
                            route: 'contracts.php-eol-second-email-candidates.index',
                            label: 'messages.sitemap.contracts.php_eol.second_email_candidates',
                            showInSidebar: false,
                            permissions: ['contract.fulfillment'],
                            id: 'php-eol-second-email-candidates-index'
                        },
                        {
                            route: 'contracts.php-eol-addon-candidates.index',
                            label: 'messages.sitemap.contracts.php_eol.addon_candidates',
                            showInSidebar: false,
                            permissions: ['contract.fulfillment'],
                            id: 'php-eol-first-addon-candidates-index'
                        },
                        {
                            route: 'contracts.php-eol-processed.index',
                            label: 'messages.sitemap.contracts.php_eol.processed_records',
                            showInSidebar: false,
                            permissions: ['contract.fulfillment'],
                            id: 'contracts.php-eol-processed-index'
                        },
                        {
                            route: 'contracts.php-eol-discarded.index',
                            label: 'messages.sitemap.contracts.php_eol.discarded_records',
                            showInSidebar: false,
                            permissions: ['contract.fulfillment'],
                            id: 'contracts.php-eol-discarded.index'
                        }
                    ]
                }
            ]
            : []
        )
    ]
}
